export const IMAGE_GROUP_WIDGET = 'Web.TemplatesInterface.v1_0.Touch.WidgetsInterface.ImageGroupWidgetElement';
